import { render, staticRenderFns } from "./GroupTimeToKillInTreeView.vue?vue&type=template&id=5056ea58&scoped=true&"
import script from "./GroupTimeToKillInTreeView.vue?vue&type=script&lang=js&"
export * from "./GroupTimeToKillInTreeView.vue?vue&type=script&lang=js&"
import style0 from "./GroupTimeToKillInTreeView.vue?vue&type=style&index=0&id=5056ea58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5056ea58",
  null
  
)

export default component.exports